/**
 * Reusable discard confirmation dialog
 * 
 * Provides consistent discard UI across all modal screens.
 * Works with useModalGuard hook.
 */

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DiscardDialog({ isOpen, onConfirm, onCancel }: Props) {
  if (!isOpen) return null;

  return (
    <div className="hub-screen-overlay" style={{ zIndex: 1001 }}>
      <div className="hub-screen hub-screen--dialog" onClick={e => e.stopPropagation()}>
        <div className="hub-screen__header">
          <h2 className="hub-screen__title">Discard changes?</h2>
        </div>
        <div className="hub-screen__body">
          <p>You have unsaved changes. Are you sure you want to discard them?</p>
        </div>
        <div className="hub-screen__footer">
          <button 
            className="hub-screen__button hub-screen__button--secondary" 
            onClick={onCancel}
          >
            Keep editing
          </button>
          <button 
            className="hub-screen__button hub-screen__button--danger" 
            onClick={onConfirm}
          >
            Discard changes
          </button>
        </div>
      </div>
    </div>
  );
}
